import { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";

export default class VerifiedClientListDateSearchFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  parent: any;
  constructor({ parent }: { parent: any }) {
    super({
      myRefName: "verifiedClientListDateSearchRef",
    });
    this.parent = parent;

    this.addField(
      new FSelectDateFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "fromDate",
        label: "From Date",
        futureDaysDisabled: false,
      })
    ).addField(
      new FSelectDateFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "toDate",
        label: "To Date",
        futureDaysDisabled: false,
      })
    );
  }
}
